import { matchPath } from 'react-router';
import get from 'lodash/get';
import last from 'lodash/last';
import { hyphenateUrlComponents } from './boats';
import {
  getCurrentRoutes as rts,
  geti18nLocations,
  getCurrentLocale
} from '../language';
import { getConfig } from '../../config/portal';
import { addResizeParams } from '../listingHelper';

export const parseBoatDetailParams = (url) => {
  let { params } = matchPath(url, rts().BOAT_DETAILS_URL_PATTERN);
  return {
    id: last(params.id.split('-'))
  };
};

export const getLocaleUrl = (url) => {
  if (!url) {
    return url;
  }
  const context = getConfig();
  const supports = get(context, 'supports');
  const multiLanguage = get(supports, 'multiLanguage');
  if (multiLanguage) {
    const urlPathname = new URL(url).pathname;
    const urlObjectArray = geti18nLocations(urlPathname);
    const locale = getCurrentLocale();
    for (const urlObject of urlObjectArray) {
      if (urlObject.lang === locale) {
        return urlObject.route;
      }
    }
  }
  return url;
};

export const getBoatUrl = (listing, fullUrl) => {
  let url = rts().BOAT_DETAILS_ROOT;
  if (fullUrl) {
    const isMultipleDomainsHost = get(getConfig(), 'supports.multipleDomainsHost', false);
    if (isMultipleDomainsHost) {
      const { subdomain, domain, tld } = get(
        getConfig(),
        `languages.${getCurrentLocale()}`
      );
      url = `https://${subdomain}.${domain}${tld}${url}`;
    } else {
      url = get(getConfig(), 'host') + url;
    }
  }
  if (listing.year) {
    url += listing.year + '-';
  }
  if (listing.make) {
    url += hyphenateUrlComponents(listing.make) + '-';
  }
  if (listing.model) {
    url += hyphenateUrlComponents(listing.model) + '-';
  }
  url += listing.id + '/';

  return url;
};

export const imageUrlWithDimensions = (url) => {
  const desktopDimensions = { width: 400, height: 267 };
  const mobileDimensions = { width: 712, height: 200 };
  const maxMobileWidth = 768;
  const isMobile =
    (typeof window !== 'undefined' && window.innerWidth <= maxMobileWidth) ||
    false;
  return addResizeParams(
    url,
    isMobile ? mobileDimensions : desktopDimensions,
    null,
    true,
    'webp'
  );
};
